import Swipeout from './Swipeout';
export default Swipeout;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-swipeout/es/index.js
// module id = 414
// module chunks = 0